import ApiService from "@/common/api.service";
import { FETCH_ROLS } from "../actions.type";
import { SET_ROLS } from "../mutations.type";

const state = {
  rols: []
};

const getters = {
  rols(state) {
    return state.rols;
  }
};

const mutations = {
  [SET_ROLS](context, newrols) {
    state.rols = newrols;
  }
};

const actions = {
  [FETCH_ROLS](context, reload = false) {
    if (state.rols.length > 0 && !reload) return Promise.resolve(context.rols);

    return ApiService.get("rols/list").then(rols => {
      context.commit(SET_ROLS, rols);
      return Promise.resolve(rols);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
